import { Component, OnInit } from '@angular/core';
import { ComisionesLayOut } from 'src/app/model/commission-layout/comisiones-layout';
import { CommissionLayoutService } from 'src/app/services/commission-layout.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

interface Opcion {
  id: number;
  opcion: string;
  columnas: string[];
  headersExcel: string[];
}

@Component({
  selector: 'app-comisiones-carga',
  templateUrl: './comisiones-carga.component.html',
  styleUrls: ['./comisiones-carga.component.css']
})
export class ComisionesCargaComponent implements OnInit {

  // Catalogo de opciones
  opciones: Opcion[] = [
    { id: 1, 
      opcion: "COORDINADOR EXTERNO", 
      columnas: ["idCredito", "idPromotor", "nombrePromotor", "fechaCobro", "capital", "colectivo", "folio", "sucursal", "producto", "estado", "zona", "montoComision", "porcentajeComision", "observaciones"],
      headersExcel: ["CREDITO", "ID PROMOTOR", "NOMBRE PROMOTOR", "FECHA DE COBRO", "CAPITAL", "COLECTIVO", "FOLIO", "SUCURSAL", "PRODUCTO", "ESTADO", "ZONA", "MONTO COMISION", "% COMISION", "OBSERVACIONES"]
    },
    // De momento no quieren lo de tercía
    // { id: 2, 
    //   opcion: 'TERCIA COMERCIAL', 
    //   columnas: ['idPromotor', 'nombrePromotor', 'fechaCobro', 'capital', 'estado', 'zona', 'montoComision', 'porcentajeComision', 'observaciones'],
    //   headersExcel: ['ID P', 'Nom Promotor', 'Fecha de Cobro', 'Capital', 'Estado', 'Zona', 'Monto Comision', '% Comision', 'Observaciones']
    // }
  ];

  // Controladores de la pagina
  errorDocument: boolean = false;
  opcionSeleccionada: Opcion | null = null;
  viewStatus: number = 0;
  documentVoBo: boolean = false; // Controla si el documento tiene VoBo
  documentoAnalizado: boolean = false; // Controla si el documento ha sido analizado
  actualizarCifrasControl: boolean = false; 
  sendResponse: boolean = false; // Controla si ya se envió la respuesta de carga
  sendEmail: boolean = false; // Controla si ya se envió el email de notificación

  // Variables
  fechaInicio: string | null = null;
  fechaFin: string | null = null;
  file: File | null = null;
  documentoFinal: any | null = null;
  cifrasControl: any | null = null;

  // Arreglo para almacenar las tablas leídas del excel
  comissionsTables: { nombre: string, headers: string[], columnas: string[], datos: any[] }[] = [];
  selectedTabIndex: number | null = null;

  // Opciones de configuración de las tablas
  dtOptions = {};

  constructor(private commissionLayoutService: CommissionLayoutService) { }

  ngOnInit() {
    this.dtOptions = {
      responsive: true,
      autoWidth: false,
      select: "single",
      bLengthChange: true,
      searching: true,
      dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
      buttons: [],
      columnDefs: [
        {
          // Buscar por el nombre de la columna
          targets: this.getColumnIndex('OBSERVACIONES'), // método helper
          responsivePriority: 1
        }
      ],
      pagingType: "full_numbers",
      paging: true,
      pageLength: 25,
      language: {
        processing: "Procesando...",
        search: "Buscar:",
        lengthMenu: "Mostrar _MENU_ elementos",
        info: "Mostrando del _START_ al _END_ de _TOTAL_ elementos",
        infoEmpty: "Mostrando ningún elemento.",
        infoFiltered: "(filtrado _MAX_ elementos total)",
        infoPostFix: "",
        loadingRecords: "Cargando registros...",
        zeroRecords: "No se encontraron registros",
        emptyTable: "No hay datos disponibles en la tabla",
        paginate: {
          first: "Primero",
          previous: "Anterior",
          next: "Siguiente",
          last: "Último",
        },
        aria: {
          sortAscending: ": Activar para ordenar la tabla en orden ascendente",
          sortDescending: ": Activar para ordenar la tabla en orden descendente",
        },
      },
    };
  }

  onFileSelected(event: any) {
    this.errorDocument = false;
    this.file = event.target.files[0];
    if (this.file && this.file.name.endsWith('.xlsx')) {
      // Mostrar indicador de carga
      Swal.fire({
        title: 'Cargando...',
        text: 'Procesando el archivo Excel',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Ejecutar la lectura del archivo y cerrar el loading al terminar
      setTimeout(() => {
        this.leerExcelPorHojas();
        Swal.close();
      }, 100); // pequeño delay para mostrar el loading
      
      // Iniciar table
      this.onTabChange(0);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Archivo inválido',
        text: 'Solo se permiten archivos Excel, extensión .xlsx',
        confirmButtonText: 'Entendido'
      });
      event.target.value = null; // limpiar selección
      this.file = null; // resetear variable de archivo
    }
  }

  leerExcelPorHojas() {
    if (this.file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data: string = e.target.result;
        const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'binary' });

        // Validar estructura según la opción seleccionada
        // De momento solo validamos COORDINADOR EXTERNO
        if (this.opcionSeleccionada.id ===1 && !this.validarEstructuraExcel(workbook, this.opcionSeleccionada.headersExcel, this.opcionSeleccionada.opcion)) {
          return;
        }

        const tablas: any[] = [];

        workbook.SheetNames.forEach((sheetName: string) => {
          const worksheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
          const sheetData = XLSX.utils.sheet_to_json(worksheet, { defval: null });
          let headers = Object.keys(sheetData[0] || {});
          let columnas = Object.keys(sheetData[0] || {});
          let datosConIdStatus = [];

          // Mapear nombres de columnas para Coordinador Externo
          if (this.opcionSeleccionada.id === 1) {
            datosConIdStatus = this.mapearDatosCoordinadorExterno(sheetData, tablas);
            headers = ["ID", "Status", ...this.opcionSeleccionada.headersExcel];
            columnas = ["ID", "Status", ...this.opcionSeleccionada.columnas];
          } else {
            // Para otras opciones, mantener comportamiento original
            const startId = tablas.reduce((acc, t) => acc + t.datos.length, 0) + 1;
            datosConIdStatus = sheetData.map((row: any, idx: number) => ({
              ID: startId + idx,
              Status: 0,
              ...row
            }));
            headers = ["ID", "Status", ...headers];
            columnas = ["ID", "Status", ...columnas];
          }

          tablas.push({ nombre: sheetName, headers: headers, columnas: columnas, datos: datosConIdStatus });
        });

        this.comissionsTables = tablas;
        console.log('Tablas leídas del Excel -> ', this.comissionsTables);
      };
      reader.readAsBinaryString(this.file);
    }
  }

  private validarEstructuraExcel(workbook: XLSX.WorkBook, columnasRequeridas: string[], tipoComision: string): boolean {
    for (let sheetName of workbook.SheetNames) {
      const worksheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(worksheet, { defval: null });
      
      if (sheetData.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Estructura inválida',
          text: `La hoja "${sheetName}" está vacía.`,
          confirmButtonText: 'Entendido'
        });
        return false;
      }

      const columnasPresentes = Object.keys(sheetData[0]).map(col => col.trim());
      const columnasFaltantes = columnasRequeridas.filter(col => !columnasPresentes.includes(col.trim()));
      
      if (columnasFaltantes.length > 0) {
        Swal.fire({
          icon: 'error',
          title: `Estructura inválida para ${tipoComision}`,
          html: `La hoja "${sheetName}" no tiene la estructura correcta.<br><br>
                <strong>Columnas faltantes:</strong><br>
                ${columnasFaltantes.join('<br>')}<br><br>
                <strong>Estructura requerida:</strong><br>
                ${columnasRequeridas.join(' | ')}`,
          confirmButtonText: 'Entendido'
        });
        return false;
      }
    }
    
    return true;
  }

  private mapearDatosCoordinadorExterno(sheetData: any[], tablas: any[]): any[] {
    const startId = tablas.reduce((acc, t) => acc + t.datos.length, 0) + 1;
    //columnas: ['idPromotor', 'nombrePromotor', 'fechaCobro', 'estado', 'zona', 'montoComision', 'porcentajeComision'],
    return sheetData.map((row: any, idx: number) => {
      // Limpiar las claves del objeto row por si existen espacios
      const cleanRow: any = {};
      Object.keys(row).forEach(key => {
        const cleanKey = key.trim();
        cleanRow[cleanKey] = row[key];
      });

      //headersExcel: ["CREDITO", "ID PROMOTOR", "NOMBRE PROMOTOR", "FECHA DE COBRO", "CAPITAL", "COLECTIVO", "FOLIO", "SUCURSAL", "PRODUCTO", "ESTADO", "ZONA", "MONTO COMISION", "% COMISION", "OBSERVACIONES"]
      let fechaCobro = this.parseExcelDate(cleanRow['FECHA DE COBRO']);
      return {
        ID: startId + idx,
        Status: 0,
        idCredito: cleanRow['CREDITO'],
        idPromotor: cleanRow['ID PROMOTOR'],
        nombrePromotor: cleanRow['NOMBRE PROMOTOR'],
        fechaCobro: fechaCobro != null ? fechaCobro.toISOString().split('T')[0] : null,
        capital: cleanRow['CAPITAL'],
        colectivo: cleanRow['COLECTIVO'],
        folio: cleanRow['FOLIO'],
        sucursal: cleanRow['SUCURSAL'],
        producto: cleanRow['PRODUCTO'],
        estado: cleanRow['ESTADO'],
        zona: cleanRow['ZONA'],
        montoComision: cleanRow['MONTO COMISION'],
        porcentajeComision: cleanRow['% COMISION'],
        observaciones: cleanRow['OBSERVACIONES']
      };
    });
  }

  onTabChange(index: number) {
    this.selectedTabIndex = index;
    this.updateWithDelay('viewStatus', 0, 1);
  }

  delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async updateWithDelay(variable: string, firstValue: any, secondValue: any) {
    this[variable] = firstValue;
    await this.delay(100);
    this[variable] = secondValue;
    await this.delay(100);
  }

  otorgarVoBo() {
    if (this.documentoAnalizado) {
      const allRows = this.comissionsTables.reduce((acc, tabla) => acc.concat(tabla.datos), []);
      console.log(allRows);
      const allValidatedOrRejected = allRows.every(row => row.Status === 1 || row.Status === 3);
      if (!allValidatedOrRejected) {
        Swal.fire({
          icon: 'warning',
          title: 'Validación incompleta',
          text: 'Todos los registros deben estar validados o rechazados antes de otorgar VoBo. Recuerda que los rechazados no se incluirán en el envío.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      Swal.fire({
        title: '¿Otorgar VoBo?',
        text: '¿Está seguro de que desea otorgar VoBo al documento?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, otorgar VoBo',
        cancelButtonText: 'Rechazar',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: 'success',
            title: 'VoBo otorgado',
            text: 'El documento ha sido validado correctamente.',
            confirmButtonText: 'Aceptar'
          });
          this.documentVoBo = true;
          this.documentoFinal = this.comissionsTables.reduce((acc, tabla) => acc.concat(tabla.datos), []);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.documentVoBo = false;
        }
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Debe analizar el documento antes de otorgar VoBo.',
        confirmButtonText: 'Entendido'
      });
      this.documentVoBo = false;
    }
  } 

  retirarVoBo() {
    this.documentVoBo = false;
  }

  onStatusChange(row: any, tabIndex: number) {
    const tabla = this.comissionsTables[tabIndex];
    const fila = tabla.datos.find((r: any) => r.ID === row.ID);
    if (fila) {
      fila.Status = row.Status;
    }
    this.calcularCifrasControl();
  }

  private calcularCifrasControl() {
    const allRows = this.comissionsTables.reduce((acc, tabla) => acc.concat(tabla.datos), []);
    const total = allRows.filter(row => row.Status === 1).length;
    const validados = allRows.filter(row => row.Status === 1).length;
    const retenidos = allRows.filter(row => row.Status === 2).length;
    const rechazados = allRows.filter(row => row.Status === 3).length;

    const rowsValidos = allRows.filter(row => row.Status !== 3);
    const sumaColocacion = rowsValidos.reduce((sum, row) => sum + (row.capital || 0), 0);
    const sumaComisiones = rowsValidos.reduce((sum, row) => sum + (row.montoComision || 0), 0);

    this.cifrasControl = {
      total: total,
      validados: validados,
      rechazados: rechazados,
      retenciones: retenidos,
      colocacion: Number(sumaColocacion.toFixed(2)),
      comisiones: Number(sumaComisiones.toFixed(2))
    };

    this.updateWithDelay('viewStatus', 0, 1);

    console.log('Cifras de control:', this.cifrasControl);
  }

  public formatNumber(value: number): string {
    return value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  public formatMoney(value: number, currency: string = 'MXN'): string {
    if (isNaN(value)) {
      return '0.00';
    }
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  public parseExcelDate(value: string | number): Date | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    // Si es número (Excel serial date)
    if (typeof value === "number") {
      // Excel cuenta desde 1900-01-01 = 1, pero considera 1900 como bisiesto
      const excelEpoch = new Date(1899, 11, 30); // 1899-12-30
      const date = new Date(excelEpoch.getTime() + value * 24 * 60 * 60 * 1000);
      return date;
    }

    if (typeof value === 'string') {
      // Posibles formatos esperados
      const formats = [
        /^\d{4}-\d{2}-\d{2}$/,     // YYYY-MM-DD
        /^\d{2}\/\d{2}\/\d{4}$/,   // DD/MM/YYYY
        /^\d{2}-\d{2}-\d{4}$/      // DD-MM-YYYY
      ];

      let parsedDate: Date | null = null;

      // Caso: YYYY-MM-DD (ISO simple)
      if (formats[0].test(value)) {
        parsedDate = new Date(value);
      }

      // Caso: DD/MM/YYYY
      else if (formats[1].test(value)) {
        const [day, month, year] = value.split('/');
        parsedDate = new Date(+year, +month - 1, +day);
      }

      // Caso: DD-MM-YYYY
      else if (formats[2].test(value)) {
        const [day, month, year] = value.split('-');
        parsedDate = new Date(+year, +month - 1, +day);
      }

      // Si es válido, regreso la fecha
      if (parsedDate && !isNaN(parsedDate.getTime())) {
        return parsedDate;
      }
    }

    // Si no lo pudo interpretar
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'No se pudo interpretar la fecha de cobro. Formato esperado: YYYY-MM-DD, DD/MM/YYYY o DD-MM-YYYY. Por favor, verifique el archivo.',
      confirmButtonText: 'Aceptar'
    });
    this.errorDocument = true;
    this.comissionsTables = [];
    return null;
  }

  analizarDocumento() {
    if (this.comissionsTables.length > 0) {
      
      let documentoFinal = this.comissionsTables.reduce((acc, tabla) => acc.concat(tabla.datos), []);
      let comisionesLayOut = this.getComisionesLayOut(documentoFinal);

      // Mostrar indicador de carga
      Swal.fire({
        title: 'Analizando...',
        text: 'Analizando comisiones',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      setTimeout(() => {
        this.commissionLayoutService.analyzeLayOutForDuplicates(comisionesLayOut).subscribe({
          next: (response: any[]) => {
            console.log('Respuesta del servidor (Analisis):', response);

            this.comissionsTables.forEach(tabla => {
              tabla.datos.forEach((row: any) => {
                // Buscar el duplicado que coincida con este row
                const duplicado = response.find((dup: any) => dup.cargaActual.fila === row.ID);

                if (duplicado) {
                  row.Status = 2; 
                  row.analisis = duplicado.mensaje; // Asignamos el mensaje devuelto
                } else {
                  row.Status = 1; // Si no es duplicado, lo marcamos como validado
                  row.analisis = 'Válido';
                }
              });
            });

            let mensaje = 'Las comisiones se han analizado correctamente';
            if (response.length > 0) {
              mensaje += ` y se han encontrado ${response.length} duplicados.`;
            }
            Swal.fire({
              icon: 'success',
              title: 'Comisiones analizadas',
              text: mensaje,
              confirmButtonText: 'Aceptar'
            });

            this.documentoAnalizado = true;
            this.onTabChange(0);
          },
          error: (error) => {
            console.error('Error al analizar el LayOut:', error);
            Swal.fire({
              icon: 'error',
              title: 'Error al analizar el LayOut',
              text: 'Ocurrió un error al analizar el LayOut. Por favor, inténtelo de nuevo más tarde.',
              confirmButtonText: 'Aceptar'
            });
          }
        });
        Swal.close();
      }, 100); // pequeño delay para mostrar el loading
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Sin datos',
        text: 'No hay tablas cargadas para analizar.',
        confirmButtonText: 'Aceptar'
      });
    }
  }

  cargarComisiones() {
    if (!this.fechaInicio || !this.fechaFin) {
      Swal.fire({
        icon: 'warning',
        title: 'Fechas requeridas',
        text: 'Debe ingresar la fecha de inicio y fin antes de cargar las comisiones.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    
    if (new Date(this.fechaFin) < new Date(this.fechaInicio)) {
      Swal.fire({
        icon: 'warning',
        title: 'Fechas inconsistentes',
        text: 'La fecha de fin no puede ser anterior a la fecha de inicio.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    
    if (this.documentoFinal && this.documentVoBo) {
      // Construir objeto para el Back
      let comisionesLayOut: ComisionesLayOut = this.getComisionesLayOut(this.documentoFinal);
      
      // Mostrar indicador de carga
      Swal.fire({
        title: 'Procesando...',
        text: 'Procesando las comisiones cargadas',
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      // Ejecutar el primer servicio (guardar layout)
      this.commissionLayoutService.saveCommissionsLayout(comisionesLayOut).subscribe({
        next: (response) => {
          console.log('Respuesta del servidor (saveCommissionsLayout):', response);
          
          // Actualizar texto del loading para mostrar progreso
          Swal.update({
            title: 'Procesando...',
            text: 'Enviando correo electrónico...',
            allowOutsideClick: false,
            showConfirmButton: false,
            showCancelButton: false
          });
          
          // Crear el reporte Excel
          const wb = this.crearReporte(true);
          const excelBuffer: ArrayBuffer = XLSX.write(wb, {
            bookType: 'xlsx',
            type: 'array'
          });
          
          // Convertir a Blob
          const excelBlob: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          
          // Preparar FormData
          const formData = new FormData();
          formData.append('documentos', excelBlob);
          formData.append('fechaCobro', comisionesLayOut.fechaInicial.toString());
          formData.append('fechaEnvio', new Date().toISOString());
          formData.append('numeroRegistros', comisionesLayOut.totalPagosUp.toString());
          formData.append('importeColocacion', comisionesLayOut.capitalUp.toString());
          formData.append('importeComisiones', comisionesLayOut.comisionesUp.toString());
          
          // Ejecutar el segundo servicio (enviar correo)
          this.commissionLayoutService.sendEmailComisionesLayOutCarga(formData).subscribe({
            next: (emailResponse) => {
              console.log('Respuesta del servidor (sendEmail):', emailResponse);
              
              // CERRAR el loading AQUÍ cuando todo haya terminado exitosamente
              Swal.close();
              
              // Mostrar mensaje de éxito
              Swal.fire({
                icon: 'success',
                title: 'Comisiones cargadas',
                text: 'Las comisiones se han cargado correctamente y se ha notificado via correo electrónico',
                confirmButtonText: 'Aceptar'
              });
              
              this.sendEmail = true;
              this.sendResponse = true;
            },
            error: (emailError) => {
              console.error('Error al enviar correo electrónico:', emailError);
              
              // CERRAR el loading AQUÍ en caso de error en el envío de correo
              Swal.close();
              
              Swal.fire({
                icon: 'error',
                title: 'Error al enviar correo electrónico',
                text: 'Las comisiones se han cargado correctamente, pero ocurrió un error al enviar el correo electrónico.',
                confirmButtonText: 'Aceptar'
              });
              
              this.sendEmail = false;
              this.sendResponse = true;
            }
          });
        },
        error: (error) => {
          console.error('Error al guardar Comisiones LayOut:', error);
          
          // CERRAR el loading AQUÍ en caso de error en el primer servicio
          Swal.close();
          
          Swal.fire({
            icon: 'error',
            title: 'Error al cargar comisiones',
            text: 'Ocurrió un error al cargar las comisiones. Por favor, inténtelo de nuevo más tarde.',
            confirmButtonText: 'Aceptar'
          });
        }
      });
      
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Cargar Comisiones',
        text: 'Debe otorgar VoBo al documento antes de cargar las comisiones.',
        confirmButtonText: 'Aceptar'
      });
    }
  }

  private getComisionesLayOut(documento): ComisionesLayOut {
    this.calcularCifrasControl();

    // Lógica para cargar las comisiones
    console.log('Cargando comisiones...', documento);
    console.log('Cifras control:', this.cifrasControl);
    console.log('UserId:', localStorage.getItem('UserId'));
    console.log('Role:', localStorage.getItem('role'));

    // Construir objetos para el Back
    let comisionesLayOut: ComisionesLayOut = {
      idComisionesLayOut: null,
      nombreDocumento: this.file.name,
      fechaInicial: this.fechaInicio || null,
      fechaFinal: this.fechaFin || null,
      status: 0,
      statusDescripcion: 'PENDIENTE',
      totalPagosUp: this.cifrasControl.total,
      pagosValidadosUp: this.cifrasControl.validados,
      pagosRetenidosUp: this.cifrasControl.retenciones,
      pagosRechazadosUp: this.cifrasControl.rechazados,
      capitalUp: this.cifrasControl.colocacion,
      comisionesUp: this.cifrasControl.comisiones,
      totalPagosSend: null,
      pagosValidadosSend: null,
      pagosRetenidosSend: null,
      pagosRechazadosSend: null,
      capitalSend: null,
      comisionesSend: null,
      createUser: localStorage.getItem('UserId') || 'unknown',
      createDate: null,
      sendUser: null,
      sendDate: null,
      typeCommissionDocument: this.opcionSeleccionada.opcion,
      comisionesLayOutCargas: documento.map(row => ({
        idComisionesLayOutCarga: null,
        fila: row.ID,
        status: row.Status,
        statusDescripcion: row.Status === 0 ? 'PENDIENTE' : row.Status === 1 ? 'VALIDADO' : row.Status === 2 ? 'RETENIDO' : 'RECHAZADO', // En teoria deberian ir todos VALIDADOS
        idCredito: row.idCredito,
        idEmpleado: row.idPromotor,
        nombreEmpleado: row.nombrePromotor,
        fechaCobro: row.fechaCobro,
        capital: row.capital,
        colectivo: row.colectivo,
        folio: row.folio,
        sucursal: row.sucursal,
        producto: row.producto,
        estado: row.estado,
        zona: row.zona,
        montoComision: row.montoComision,
        porcentajeComision: row.porcentajeComision,
        observaciones: row.observaciones
      })),
      comisionesLayOutEnvios: []
    };

    console.log('Comisiones LayOut:', comisionesLayOut);
    return comisionesLayOut;
  }

  crearReporte(docValidado : boolean = false): XLSX.WorkBook {
    if (!this.opcionSeleccionada || this.comissionsTables.length === 0) return;

    // Crear workbook
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    this.comissionsTables.forEach((tabla, index) => {
      const headers = tabla.headers.filter(header => !docValidado || docValidado && header !== 'Status' && header !== 'ID'); // Si es reporte validado, no incluir Status ni ID
      const columnas = tabla.columnas.filter(col => !docValidado || docValidado && col !== 'Status' && col !== 'ID'); // Si es reporte validado, no incluir Status ni ID
      const ws_data: any[][] = [];
      const numCols = headers.length;

      // Primera fila: nombre de la opción (mergeado en todas las columnas)
      const firstRow = Array(numCols).fill('');
      firstRow[0] = this.opcionSeleccionada.opcion;
      ws_data.push(firstRow);

      // Segunda fila: headers
      ws_data.push(headers);

      // Filas de datos
      tabla.datos
        .filter(row => !docValidado || docValidado && row.Status === 1) // Solo incluir los validados
        .forEach(row => {
          const fila: any[] = [];
          tabla.columnas
            .filter(col => columnas.includes(col))
            .forEach(header => {
              if(header === 'Status'){
                // 0 - Pendiente, 1 - Validado, 2 - Retenido, 3 - Rechazado
                let statusLabel = '';
                switch(row[header]) {
                  case 0:
                    statusLabel = 'Pendiente';
                    break;
                  case 1:
                    statusLabel = 'Validado';
                    break;
                  case 2:
                    statusLabel = 'Retenido';
                    break;
                  case 3:
                    statusLabel = 'Rechazado';
                    break;
                  default:
                    statusLabel = 'Desconocido';
                }
                fila.push(statusLabel);
              } else {
                fila.push(row[header]);
              }
            }
          );
          ws_data.push(fila);
        }
      );

      // Crear worksheet
      const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(ws_data);

      // Combinar la primera fila
      ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }];

      // Ajustar ancho de columnas
      ws['!cols'] = tabla.headers.map(h => ({ wch: Math.max(h.length, 15) }));

      // Agregar hoja al libro (nombre dinámico por cada tabla)
      const sheetName = tabla.nombre || `Hoja${index + 1}`;
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    return wb;
  }

  descargarReporte() {
    const wb = this.crearReporte();

    // Descargar Excel con todas las hojas
    XLSX.writeFile(wb, `${this.opcionSeleccionada.opcion}.xlsx`);
  }

  editarObservacion(row: any, tabIndex: number) {
    console.log('Editar observación para fila:', row);
    Swal.fire({
      title: 'Editar Observación',
      input: 'text',
      inputLabel: 'Observación',
      inputValue: row.observaciones || '',
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        if (value && value.length > 200) {
          return 'La observación no puede exceder los 200 caracteres.';
        }
        return null;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        row.observaciones = result.value;
        const tabla = this.comissionsTables[tabIndex];
        const fila = tabla.datos.find((r: any) => r.ID === row.ID);
        if (fila) {
          fila.observaciones = row.observaciones;
        }
        Swal.fire({
          icon: 'success',
          title: 'Observación actualizada',
          text: 'La observación ha sido guardada correctamente.',
          confirmButtonText: 'Aceptar'
        });
      }
    });

  }

  showCompleteMessage(message: string){
    Swal.fire({
      icon: 'info',
      title: 'Detalle',
      html: `<div style="text-align: justify;">${message}</div>`,
      confirmButtonText: 'Aceptar'
    });
  }

  reenviarCorreo() {
    // Mostrar loading
    Swal.fire({
      title: 'Enviando...',
      text: 'Enviando comisiones',
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // Preparar datos 
    let comisionesLayOut: ComisionesLayOut = this.getComisionesLayOut(this.documentoFinal);

    const wb = this.crearReporte(true);
    const excelBuffer: ArrayBuffer = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const excelBlob: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const formData = new FormData();
    formData.append('documentos', excelBlob);
    formData.append('fechaCobro', comisionesLayOut.fechaInicial.toString());
    formData.append('fechaEnvio', new Date().toISOString());
    formData.append('numeroRegistros', comisionesLayOut.totalPagosUp.toString());
    formData.append('importeColocacion', comisionesLayOut.capitalUp.toString());
    formData.append('importeComisiones', comisionesLayOut.comisionesUp.toString());

    // Ejecutar el servicio y cerrar loading solo cuando termine
    this.commissionLayoutService.sendEmailComisionesLayOutCarga(formData).subscribe({
      next: (response) => {
        console.log('Respuesta del servidor:', response);
        
        // CERRAR el loading AQUÍ cuando el servicio termine exitosamente
        Swal.close();
        
        // Mostrar mensaje de éxito
        Swal.fire({
          icon: 'success',
          title: 'Comisiones enviadas',
          text: 'Se ha notificado via correo electrónico',
          confirmButtonText: 'Aceptar'
        });
        
        this.sendEmail = true;
      },
      error: (error) => {
        console.error('Error al enviar correo electrónico:', error);
        
        // CERRAR el loading AQUÍ en caso de error
        Swal.close();
        
        Swal.fire({
          icon: 'error',
          title: 'Error al enviar correo electrónico',
          text: 'Ocurrió un error al enviar el correo electrónico.',
          confirmButtonText: 'Continuar'
        });
        
        this.sendEmail = false;
      }
    });
  }

  getColumnIndex(columnName: string): number {
    if (this.selectedTabIndex === null) return -1;

    const headers = this.comissionsTables[this.selectedTabIndex].headers || [];
    const index = headers.findIndex(header => 
      header.toLowerCase() === columnName.toLowerCase()
    );
    
    return index;
  }
}